module.exports = __webpack_public_path__ + "static/media/bubble-gum-workflow.b2859374.gif";